import { styled } from "../../style";

const Text = styled.Text();

export default Text;
